// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateBrazilianZipcode(zipcodeValue: string): ?UserInputValidationError {
  if (!zipcodeValue || zipcodeValue.trim() === '')
    return { id: 'empty' };
  else if (!/^\d{8}$/.test(zipcodeValue))
    return { id: 'invalid-pattern' };
}
